import { useState } from "react";
import marker_icon from "assets/images/location-marker.png";
import { PractitionerService } from "utils/PractitionerService";
import { Link } from "react-router-dom";
import { useRef } from "react";
import { Button, Card, CardBody } from "reactstrap";
import { useEffect } from "react";
import { createImageFromInitials, getRandomColor } from "utils/Utils";
import { encrypt } from "utils/EncryptDecrypt";
import NoConnection from "pages/Connections/components/NoConnection";
import CommonLoader from "common/CommonLoader";
import { useSelector } from "react-redux";

const PeopleKnowWidget = (props) => {
    const { speciality } = props;
    const [practitioners, setPractitioners] = useState([]);
    const [hasMore, setHasMore] = useState(false);
    const currentPage = useRef(0);
    const [isLoading, setIsLoading] = useState(true);
    const currentUser = useSelector((state) => state.auth.currentUser);

    const fetchData = () => {
        try {
            const pageNo = currentPage.current + 1;
            currentPage.current = pageNo;

            PractitionerService.getPractitionerProfiles(`ps == '*${currentUser?.primarySpeciality}*'`, pageNo)
                .then((response) => {
                    if (response.status === 200) {
                        const { currentPage, totalPages, contents } = response.data;
                        setPractitioners((prevPractitioners) => [...prevPractitioners, ...contents]);
                        setHasMore(totalPages - currentPage !== 1);
                    }
                })
                .catch((err) => {
                    console.log(err.message);
                });
        } catch (e) {
            if (alert) alert.error(e.message);
        }
    };

    useEffect(() => {
        PractitionerService.getPractitionerProfiles(`ps == '*${currentUser?.primarySpeciality}*'`, 0)
            .then((response) => {
                if (response.status === 200) {
                    const { currentPage, totalPages, contents } = response.data;
                    setPractitioners(contents);
                    setIsLoading(false);
                    setHasMore(totalPages - currentPage !== 1);
                }
            })
            .catch((err) => {
                setIsLoading(false);
                console.log(err.message);
            });
    }, [currentUser?.primarySpeciality]);


    return (
        <Card className="nexogic-widget-sidebar-card job-card bg-white">
            <h3 className="nex-aside-title">People you may Know <span className="icon ml-auto"><svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.9531 22C12.1831 21.99 11.4231 21.79 10.7531 21.42C10.2831 21.16 9.85313 20.81 9.50313 20.4C8.95312 20.45 8.40312 20.4 7.87313 20.24C7.12313 20.03 6.44313 19.62 5.89313 19.07C5.34313 18.52 4.95312 17.84 4.74312 17.1C4.59312 16.58 4.53313 16.03 4.57313 15.49C4.15313 15.13 3.80313 14.7 3.53312 14.22C3.15312 13.55 2.95312 12.78 2.95312 12C2.95312 11.22 3.15312 10.45 3.53312 9.77C3.80313 9.3 4.15313 8.87 4.56313 8.51C4.52313 7.97 4.57313 7.43 4.72312 6.91C4.93313 6.17 5.33313 5.49 5.86313 4.94C6.69313 4.11 7.79313 3.63 8.96313 3.58C9.14313 3.58 9.29313 3.58 9.46313 3.6C9.82313 3.18 10.2531 2.84 10.7331 2.57C11.4031 2.2 12.1731 2 12.9431 2C12.9431 2 12.9431 2 12.9531 2C13.7231 2 14.4831 2.2 15.1631 2.57C15.6431 2.83 16.0731 3.18 16.4231 3.59C16.9731 3.55 17.5231 3.61 18.0531 3.76C18.7931 3.98 19.4731 4.38 20.0231 4.92C20.5731 5.47 20.9731 6.15 21.1831 6.89C21.3331 7.42 21.3931 7.97 21.3531 8.51C21.7631 8.87 22.1131 9.3 22.3831 9.78C22.7531 10.46 22.9531 11.23 22.9531 12C22.9531 12.77 22.7531 13.53 22.3831 14.21C22.1231 14.69 21.7731 15.12 21.3631 15.47C21.4031 16.02 21.3431 16.57 21.1931 17.1C20.9731 17.84 20.5731 18.52 20.0231 19.07C19.4731 19.62 18.7931 20.02 18.0531 20.24C17.5231 20.39 16.9731 20.45 16.4331 20.41C16.0731 20.82 15.6431 21.17 15.1631 21.44C14.4931 21.8 13.7231 22 12.9531 22ZM9.94312 18.33C10.2831 18.33 10.6031 18.5 10.7831 18.79C11.0131 19.16 11.3431 19.46 11.7131 19.67C12.1031 19.88 12.5331 20 12.9631 20C13.3931 20 13.8231 19.89 14.2131 19.68C14.5931 19.47 14.9231 19.16 15.1531 18.8C15.3831 18.44 15.8031 18.27 16.2131 18.36C16.6431 18.46 17.0831 18.44 17.5031 18.32C17.9231 18.2 18.3031 17.97 18.6131 17.66C18.9231 17.35 19.1531 16.97 19.2731 16.55C19.3931 16.13 19.4031 15.68 19.3131 15.26C19.2231 14.85 19.3931 14.43 19.7531 14.2C20.1231 13.96 20.4231 13.64 20.6331 13.26C20.8431 12.87 20.9531 12.43 20.9531 12C20.9531 11.56 20.8431 11.13 20.6331 10.75C20.4231 10.37 20.1131 10.04 19.7531 9.81C19.3931 9.58 19.2231 9.16 19.3131 8.75C19.4131 8.32 19.3931 7.88 19.2731 7.46C19.1531 7.04 18.9231 6.65 18.6131 6.35C18.3031 6.04 17.9231 5.81 17.5031 5.69C17.0831 5.57 16.6331 5.56 16.2131 5.65C15.8031 5.75 15.3831 5.57 15.1531 5.21C14.9231 4.84 14.5931 4.54 14.2131 4.33C13.8231 4.11 13.3831 4 12.9531 4C12.5131 4 12.0731 4.11 11.6931 4.32C11.3131 4.53 10.9831 4.84 10.7531 5.21C10.5231 5.58 10.0831 5.75 9.66313 5.65C9.45312 5.6 9.23313 5.57 9.02313 5.58C8.38313 5.6 7.76312 5.88 7.29313 6.34C6.99312 6.64 6.77312 7.03 6.65313 7.45C6.53313 7.87 6.52313 8.31 6.62313 8.74C6.71312 9.15 6.54313 9.58 6.18313 9.81C5.80312 10.04 5.49312 10.37 5.28312 10.75C5.07312 11.13 4.95312 11.57 4.95312 12C4.95312 12.44 5.06312 12.87 5.28312 13.26C5.49312 13.64 5.80312 13.97 6.17313 14.2C6.53312 14.43 6.71312 14.85 6.62313 15.27C6.52313 15.69 6.54313 16.14 6.66313 16.56C6.78312 16.98 7.00313 17.36 7.31313 17.67C7.62313 17.97 8.00312 18.2 8.42312 18.32C8.84312 18.44 9.29313 18.45 9.72312 18.35C9.79313 18.34 9.87312 18.33 9.94312 18.33Z" fill="black" />
                <path d="M11.9556 15.0003C11.6956 15.0003 11.4456 14.9003 11.2456 14.7103C10.8556 14.3203 10.8556 13.6903 11.2456 13.3003L15.2456 9.30031C15.6356 8.91031 16.2656 8.91031 16.6556 9.30031C17.0456 9.69031 17.0456 10.3203 16.6556 10.7103L12.6556 14.7103C12.4656 14.9003 12.2156 15.0003 11.9556 15.0003Z" fill="black" />
                <path d="M11.9556 15.0003C11.6956 15.0003 11.4456 14.9003 11.2456 14.7103L9.24562 12.7103C8.85563 12.3203 8.85563 11.6903 9.24562 11.3003C9.63563 10.9103 10.2656 10.9103 10.6556 11.3003L12.6556 13.3003C13.0456 13.6903 13.0456 14.3203 12.6556 14.7103C12.4656 14.9003 12.2156 15.0003 11.9556 15.0003Z" fill="black" />
            </svg>
            </span></h3>
            <CardBody>
                {isLoading ?
                    <div className="text-center">
                        <CommonLoader />
                    </div>
                    :
                    <>
                        <div className="nexogic-custom-scroll" style={{ height: "500px", overflow: "auto" }}>
                            <div className="card-group nexogic-card-group-list">
                                {practitioners.map((item, index) => (
                                    <div className="card" key={`job_list${index} `}>
                                        <div className="row no-gutters align-items-start">
                                            {
                                                <div className="col-auto icon">
                                                    <Link to={`/profile/${item?.profileId}`}>
                                                        {item && item.avatarId ? (
                                                            <img
                                                                src={`${process.env.REACT_APP_IMAGE_BASE_URL}/${item?.profileGuid}/${item?.avatarId}`}
                                                                className="card-img"
                                                                alt="#"
                                                            />
                                                        ) : (
                                                            <img
                                                                src={createImageFromInitials(
                                                                    50,
                                                                    `${item?.name} `,
                                                                    getRandomColor(encrypt(item?.profileGuid).toString())
                                                                )}
                                                                className="card-img"
                                                                alt="#"
                                                            />
                                                        )}
                                                    </Link>
                                                </div>
                                            }
                                            <div className="col">
                                                <h4 className="card-title">
                                                    {item?.name && (
                                                        <Link to={`/profile/${item?.profileId}`}>
                                                            {item?.name}
                                                            {", "}
                                                            {item?.qualification}
                                                        </Link>
                                                    )}
                                                </h4>
                                                <p className="card-text">
                                                    {item?.primarySpeciality && (
                                                        <small className="text-muted">
                                                            {item?.primarySpeciality}
                                                        </small>
                                                    )}
                                                </p>
                                                <p className="card-text">
                                                    <small className="text-muted"><img src={marker_icon} alt="#" /> {item?.location}{" "}
                                                        {item?.city}</small>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                ))}

                                {practitioners.length === 0 && <NoConnection content={"No Candidate"} />}

                            </div>
                        </div>

                        {practitioners.length > 0 && hasMore && (
                            <div className="mt-2">
                                <Button color="link" className="readmore btn-link" onClick={fetchData}>
                                    View More
                                </Button>
                            </div>
                        )}
                    </>
                }
            </CardBody>
        </Card>
    )
}

export default PeopleKnowWidget;